import { DateCellTemplate } from '@silevis/reactgrid';

// 붙여넣은 날짜 텍스트를 명시적 규칙으로 파싱 (브라우저/로케일 무관)
// - 연도 선행: YYYY-MM-DD, YYYY.MM.DD, YYYY/MM/DD
// - 연도 후행: DD-MM-YYYY, DD.MM.YYYY, DD/MM/YYYY (맨 앞을 일자로 해석)
export const parsePastedDate = text => {
  if (!text) return undefined;
  const trimmed = String(text).trim();

  const yearFirst = /^(\d{4})[-./](\d{1,2})[-./](\d{1,2})$/.exec(trimmed);
  const yearLast = /^(\d{1,2})[-./](\d{1,2})[-./](\d{4})$/.exec(trimmed);

  let year, month, day;
  if (yearFirst) {
    year = Number(yearFirst[1]);
    month = Number(yearFirst[2]);
    day = Number(yearFirst[3]);
  } else if (yearLast) {
    day = Number(yearLast[1]);
    month = Number(yearLast[2]);
    year = Number(yearLast[3]);
  } else {
    return undefined;
  }

  if (month < 1 || month > 12 || day < 1 || day > 31) return undefined;

  const date = new Date(year, month - 1, day);
  // 2월 30일 등 존재하지 않는 날짜의 월 롤오버 방지
  if (date.getMonth() !== month - 1 || date.getDate() !== day) {
    return undefined;
  }

  return date;
};

// built-in 템플릿은 Date.parse(브라우저 엔진 의존, 연도 후행 형식을 월/일 순서로
// 해석)에 의존하므로, 붙여넣기 텍스트를 직접 파싱하도록 update만 오버라이드
export class CustomDateCellTemplate extends DateCellTemplate {
  update(cell, cellToMerge) {
    const parsed = parsePastedDate(cellToMerge.text);
    if (parsed) {
      return this.getCompatibleCell({ ...cell, date: parsed });
    }
    return super.update(cell, cellToMerge);
  }
}
